import styled from 'styled-components'

interface PropsIcon {
  id?: string;
  size: "sm" | "md" | "lg" | "xg";
}

export const Icon = styled.span<PropsIcon>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  svg{
    ${props => props.theme.sizes[props.size]}
  }
`